import React from "react";
import { Typography, Box } from "@material-ui/core";

interface Props {
  message?: any;
  size?: number;
}

export default function NoRecordFound({ message, size }: Props) {
  return (
    <>
      <Box
        style={{
          marginLeft: "42%",
        }}
      >
        <Typography style={{ fontSize: 16, marginLeft: 7, color: "lightblue" }} color="textPrimary">
          {"OOOPS!"}
        </Typography>
        <Typography style={{ fontSize: 11, display: "block" }} color="textPrimary">
          {message || "No record found"}
        </Typography>
      </Box>
    </>
  );
}
